import EncountersRegist from "../../components/dashboard/encounters/EncountersRegist";

function Login() {
  return <EncountersRegist />;
}

export default Login;
